import React, { type ReactNode } from 'react';
import { cn } from '../lib/cn';

interface ButtonProps {
  children: ReactNode
  onClick?: () => void;
  className?: string;
  variant?: 'dark' | 'outline';
}

export default function Button({ children, onClick, className, variant = 'dark' }: ButtonProps) {
  const base = 'inline-flex items-center justify-center min-h-[40px] px-4 cursor-pointer transition-colors font-trispace type-button';
  const styles = variant === 'dark'
    ? 'bg-black text-white hover:bg-neutral-800'
    : 'bg-transparent border border-current text-black hover:bg-black hover:text-white';

  return (
    <button onClick={onClick} className={cn(base, styles, className)}>
      {children}
    </button>
  );
}
